<template>
  <div v-if="showLineup" class="row">
    <!-- congress -->
    <div class="col-12 col-xl-7">
      <article class="fc-m-container ">
        <h3 class="fc-a-text--size-6 mb-0">Senate</h3>
        <team-congress-list
          v-on:drop="drop"
          :members="senators"
          :show-buttons="showButtons"
          :limit="4"
          :active-week="activeWeek"
        >
        </team-congress-list>

        <h3 class="fc-a-text--size-6 mb-0 pt-4">House</h3>
        <team-congress-list
          v-on:drop="drop"
          :members="representatives"
          :show-buttons="showButtons"
          :limit="6"
          :active-week="activeWeek"
        >
        </team-congress-list>
      </article>
    </div>

    <div class="col-12 col-xl-5">
      <!-- lineups -->
      <lineups
        v-on:paginate-lineups="paginateLineups"
        v-on:update-lineup="updateLineup"
        :lineups="LULM"
        :league="LM.data"
        :active-week="activeWeek"
      ></lineups>
      <!-- team details -->
      <team-detail
        :league="LM.data"
        :team="TM.data"
        :is-owner="currentUserIsOwner"
      >
      </team-detail>
    </div>
  </div>
  <loader v-else :embeded="false"></loader>
</template>

<script>
import moment from "moment";
import { catchHttpError } from "@/utils/V2errors.js";

import Loader from "@/views/components/Loader";
import Pagination from "@/views/components/Pagination";
import TeamDetail from "@/views/components/team/Detail";
import TeamCongressList from "@/views/components/team/TeamCongressList";
import TeamLineups from "@/views/components/team/Lineups";
import BreadcrumbMixin from "@/mixins/breadcrumb";

import { LeagueManager } from "@/modules/managers/league.js";
import { TeamManager } from "@/modules/managers/team.js";
import { LineupListManager } from "@/modules/managers/lineup.js";
import { CongressListManager } from "@/modules/managers/congress.js";

export default {
  name: "LeaguesCreate",
  components: {
    loader: Loader,
    pagination: Pagination,
    teamDetail: TeamDetail,
    teamCongressList: TeamCongressList,
    lineups: TeamLineups
  },
  mixins: [BreadcrumbMixin],
  data: function() {
    return {
      LM: new LeagueManager(),
      TM: new TeamManager(),
      LULM: new LineupListManager(),
      CLM: new CongressListManager(),
      senators: null,
      representatives: null,
      showLineup: false,
      currentUserIsOwner: false,
      activeWeek: null
    };
  },
  created: function() {
    this.getLeague();
  },
  methods: {
    drop: function(id) {
      let c = this;

      this.TM.drop(id)
        .then(response => {
          c.$store.commit("alert/addMessage", {
            message: "Legislator dropped from team!",
            class: "success",
            persist: false
          });

          c.pageRefresh();
        })
        .catch(e => catchHttpError(e));
    },
    getLeague: function() {
      let c = this;
      // get league data
      c.LM.get(c.$route.params.leagueId)
        .then(result => {
          // set team data
          c.TM.data = c.LM.getTeam(c.$route.params.teamId);
          c.currentUserIsOwner = c.TM.isUserOwner(c.$store.state.auth.user_id);
          // get lineup data
          c.LULM.get(c.LM.data.id, c.TM.data.id, 4, 0)
            .then(result => {
              // get members of congress
              if (c.LM.data.current_week === c.LM.data.season_length) {
                c.activeWeek = c.LM.data.current_week;
              }
              c.updateLineup(c.activeWeek).then(result => {
                c.showLineup = true;
              });
            })
            .catch(e => catchHttpError(e));
        })
        .then(result => {
          c.updateBreadcrumb({
            links: [
              {
                static_name: ":league",
                dynamic_name: this.LM.data.name,
                url: `/leagues/${this.LM.data.id}`
              }
            ],
            currentPage: this.TM.data.name
          });
        })
        .catch(e => catchHttpError(e));
    },
    getCongressApiFilters: function(lineup) {
      const league = this.LM.data;
      let allFilters = {};

      if (lineup !== undefined) {
        allFilters.id__in = lineup.data.congress.join(",");
        allFilters.points__gte = lineup.data.week_start;
        allFilters.points__lte = lineup.data.week_end;
      } else {
        allFilters.id__in = this.TM.data.congress.join(",");
      }

      if (league.status === "Complete") {
        let seasonStart = moment(league.draft_date, "YYYY-MM-DD")
          .utc()
          .startOf("week")
          .add(1, "days");
        let correctedWks = league.season_length + 1;
        let seasonEnd = moment(league.draft_date, "YYYY-MM-DD")
          .utc()
          .startOf("week")
          .add(correctedWks, "weeks");

        allFilters.action__created__gte = seasonStart.format("YYYY-MM-DD");
        allFilters.action__created__lte = seasonEnd.format("YYYY-MM-DD");
      }

      return allFilters;
    },
    updateLineup: function(newLineupWeek) {
      this.senators = null;
      this.representatives = null;
      this.activeWeek = newLineupWeek;

      const newLineup = this.LULM.data.find(
        lineup => lineup.data.week_number === newLineupWeek
      );
      const hasMembers =
        newLineup === undefined
          ? this.TM.data.congress.length
          : newLineup.data.congress.length;

      if (hasMembers) {
        const filters = this.getCongressApiFilters(newLineup);

        return this.CLM.get(10, 0, filters)
          .then(result => {
            this.senators = this.CLM.data.filter(
              m => m.data.chamber === "Senate"
            );
            this.representatives = this.CLM.data.filter(
              m => m.data.chamber === "House"
            );
          })
          .catch(e => catchHttpError(e));
      } else {
        this.senators = [];
        this.representatives = [];
        return Promise.resolve(true);
      }
    },
    paginateLineups: function(direction) {
      if (direction === "next") {
        this.LULM.next().catch(e => catchHttpError(e));
      } else if (direction == "previous") {
        this.LULM.previous().catch(e => catchHttpError(e));
      }
    },
    pageRefresh: function() {
      this.showLineup = false;
      this.getLeague();
    }
  },
  computed: {
    showButtons: function() {
      return (
        this.currentUserIsOwner &&
        this.LM.data.status === "In Progress" &&
        this.activeWeek === null
      );
    }
  }
};
</script>

<style lang="scss">
table.fc-m-team td {
  vertical-align: top;
}
</style>
